import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Brain, MessageSquare, LayoutDashboard, Globe, Users, TrendingUp, AlertTriangle, Rocket, Target, BarChart, Clock, DollarSign, Megaphone, ArrowRight } from "lucide-react";
import { Slide } from "./Slide";
// Import your orderedSlides array here
// Due to length, I'll keep the array in a separate file and import it
export const PitchDeck = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % orderedSlides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + orderedSlides.length) % orderedSlides.length);
  };
  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight") {
        nextSlide();
      } else if (e.key === "ArrowLeft") {
        prevSlide();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-1369">
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-1370">
        <div className="relative" data-id="element-1371">
          <Slide {...orderedSlides[currentSlide]} data-id="element-1372" />
          <button onClick={prevSlide} className="absolute top-1/2 -translate-y-1/2 left-4 p-3 rounded-full bg-white shadow-md hover:bg-gray-50 transition-all duration-200 hover:shadow-lg" aria-label="Previous slide" data-id="element-1373">
            <ChevronLeft className="w-6 h-6" data-id="element-1374" />
          </button>
          <button onClick={nextSlide} className="absolute top-1/2 -translate-y-1/2 right-4 p-3 rounded-full bg-white shadow-md hover:bg-gray-50 transition-all duration-200 hover:shadow-lg" aria-label="Next slide" data-id="element-1375">
            <ChevronRight className="w-6 h-6" data-id="element-1376" />
          </button>
        </div>
        <div className="flex justify-center mt-8 gap-2" data-id="element-1377">
          {orderedSlides.map((_, index) => <button key={index} className={`w-2 h-2 rounded-full transition-colors ${index === currentSlide ? "bg-[#6366f1]" : "bg-gray-300"}`} onClick={() => setCurrentSlide(index)} aria-label={`Go to slide ${index + 1}`} data-id="element-1378" />)}
        </div>
      </div>
    </div>;
};